import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.hasAnimated = false;

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.disconnect();
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !window.isSorting && !this.hasAnimated) {
        this.element.classList.add("animate-fade-in");
        this.hasAnimated = true;
      } else if (window.isSorting) {
        this.element.classList.remove("animate-fade-in");
        this.hasAnimated = false;
      }
    });
  }
}
